import { Component, OnInit, Input } from '@angular/core';
import { SdaiService } from '../../create-application/sdai-form/sdai.service';
import { LoginService } from '../../shared/services/login.service';

import { AppHistoryDetails } from '../../shared/data-objects/app-history-details';
import { FormControl, Validators } from '@angular/forms';
import { User } from '../../shared/data-objects/user';
import { FeatureToggle } from '../../shared/data-objects/feature-toggle';
import { FeatureToggleService } from '../../shared/services/feature-toggle.service';

const accountNoRE = /^999\d{8}$/;

@Component({
  selector: 'app-my-applications',
  templateUrl: './my-applications.component.html',
  styleUrls: ['./my-applications.component.css']
})
export class MyApplicationsComponent implements OnInit {

  applicantDetails: User;

  applications: AppHistoryDetails[];
  noApplicationsFound = true;
  accountNumber: string;
  validAccount = false;
  accountNoControl: FormControl;

  isRequesting: boolean;
  loadingMessage: string;
  errorMessage: string;

  _feature: FeatureToggle;

  async getFeatureToggle() {
    this._feature = this.featureToggleService.features;
    if (!this._feature) {
      await this.featureToggleService.fetchFeatureToggles();
      this._feature = this.featureToggleService.features;
    }
  }

  constructor(private loginService: LoginService, private sdaiService: SdaiService, private featureToggleService: FeatureToggleService) {
    this.applications = [];
    this.accountNoControl = new FormControl('');
  }

  async ngOnInit() {
    await this.getFeatureToggle();
    await this.loginService.refreshToken();

    // this.accountNoControl = this._feature.DisableGuestUsers
    //     ? new FormControl('')
    //     : new FormControl('', [Validators.compose([Validators.required, Validators.pattern(accountNoRE)])]);

    if (!this.isTechCSOUserLoggedIn()) {
      this.retrieveApplications();
    }
  }

  isTechCSOUserLoggedIn(): boolean {
    return this.loginService.isTechCSOUserLoggedIn() || this.loginService.isSystemAdminUserLoggedIn();
  }

  onRetrieveClick() {
    this.accountNoControl.markAsTouched();
    if (!this.accountNoControl.invalid) {
      this.validateApplication();
    }
  }
  get companyName() {
    if (!this.applicantDetails) {
      return '';
    } else {
      return this.applicantDetails.accountName;
    }
  }
  get postalAddress() {
    if (!this.applicantDetails) {
      return '';
    } else {
      return this.applicantDetails.postalAddress
    }
  }
  private validateApplication() {
    this.applicantDetails = new User();
    this.applications = [];
    this.isRequesting = true;
    this.noApplicationsFound = true;
    this.validAccount = false;
    this.loadingMessage = 'Validating account';
    this.errorMessage = '';
    this.loginService.verifyAccount(this.accountNumber).subscribe((user: User) => {
      if (user == null) {
        this.isRequesting = false;
        this.errorMessage = 'Account does not exist';
        this.validAccount = false;
      } else {
        this.applicantDetails.accountName = user.accountName;
        this.applicantDetails.postalAddress = user.postalAddress;
        this.noApplicationsFound = false;
        this.validAccount = true;
        this.retrieveApplications();
      }
    }, err => {
      this.errorMessage = 'Account does not exist';
      this.isRequesting = false;
    });
  }
  private retrieveApplications() {
    this.applications = [];
    this.isRequesting = true;
    this.loadingMessage = 'Retrieving applications';
    this.errorMessage = '';
    this.sdaiService.get(this.accountNumber,
      this.loginService.getToken()).subscribe((applications) => {
        this.isRequesting = false;
        if (applications == null || applications.length === 0) {
          this.noApplicationsFound = true;
        } else {
          this.noApplicationsFound = false;
          this.applications = applications;
        }
      }, err => {
        // Log errors if any
        this.isRequesting = false;
        this.errorMessage = 'Error retrieving applications';
        this.noApplicationsFound = true;
        console.log(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-applications/my-applications/my-applications.component.ts